
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/intelcom",
      function () {
        return require("private-next-pages/partners/intelcom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/intelcom"])
      });
    }
  